import React from 'react';
import { useTheme } from 'styled-components';
import { cssClasses, ListItemTitleDescIconSC } from './list-item-title-desc-icon.styled';
import classNames from 'classnames';

interface ListItemTitleDescIconProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  Icon?: (p: React.SVGProps<SVGSVGElement>) => JSX.Element;
  className?: string;
}

const ListItemTitleDescIcon: React.FunctionComponent<ListItemTitleDescIconProps> = ({
  description,
  title,
  Icon,
  className,
}) => {
  const theme = useTheme();

  return (
    <ListItemTitleDescIconSC className={classNames(cssClasses.wrapper, className)}>
      <div className={cssClasses.title}>{title}</div>
      {description || Icon ? (
        <div className={cssClasses.descriptionWrapper}>
          {description ? <div className={cssClasses.description}>{description}</div> : null}
          {Icon ? (
            <Icon
              className={cssClasses.icon}
              color={theme.color.tint.tertiary}
              width={16}
              height={16}
              style={{ marginLeft: description ? 4 : 0 }}
            />
          ) : null}
        </div>
      ) : null}
    </ListItemTitleDescIconSC>
  );
};

export default ListItemTitleDescIcon;
